import { render, staticRenderFns } from "./MatchCounter.vue?vue&type=template&id=67923bad&scoped=true&"
import script from "./MatchCounter.vue?vue&type=script&lang=js&"
export * from "./MatchCounter.vue?vue&type=script&lang=js&"
import style0 from "./MatchCounter.vue?vue&type=style&index=0&id=67923bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67923bad",
  null
  
)

export default component.exports